import { feedManagerApi } from './api'
import { STATUS_IN_PROGRESS } from './config/constants'
import { IHoldingEntitlements } from '@/types/holdingEntitlements'
import { ISchedule } from '@/types/schedules'
import { AxiosResponse } from 'axios'

export const getHoldingsEntitlements =
  async (): Promise<IHoldingEntitlements> => {
    try {
      const { data = [] } = await feedManagerApi.get('/holdings-entitlements')
      if (Array.isArray(data.packages)) {
        data.packages = data.packages.filter(
          // Filter packages to include only those in the range 81 to 88 these are what control holdings entitlements
          (pkg: number) => pkg >= 81 && pkg <= 88
        )
      }
      console.log('getHoldingsEntitlements', data)
      return data
    } catch (error) {
      return {
        packages: [],
        portfolio_supression_client_ids: [],
      } as IHoldingEntitlements
    }
  }
